import { ThemeOptions } from '@mui/material/styles';

export const breakpointsBaseTheme: ThemeOptions = {
  breakpoints: {
    values: {
      xs: 1024,
      sm: 1024,
      md: 1280,
      lg: 1440,
      xl: 1920,
      '2xl': 2560,
      '4xl': 3840,
    },
  },
  spacing: (factor: number) => `${0.25 * factor}rem`,
};
